<template>
  <div class="text-center p-40">
    <el-button size="medium" type="primary" @click="go">
      去考试
    </el-button>
  </div>
</template>
<script>
export default {
  methods: {
    go(){
      this.$router.push('/pages/web/examination')
    }
  }
};
</script>
<style lang="scss">

</style>
